import api from './api';
import {
  LabelOption,
  LabelOptionsParams,
  MergeLabelsData,
  DeleteLabelData,
  LabelMutationResult,
} from '../types/labels';

/**
 * Labels Service
 *
 * Single canonical source for label pickers/filters: GET /api/labels/options.
 */
export const labelsService = {
  /**
   * GET /api/labels/options?q=&limit=
   * Content-derived, case-insensitive, sorted count desc then name asc.
   */
  getOptions: async (params: LabelOptionsParams = {}): Promise<LabelOption[]> => {
    const response = await api.get<{ labels: LabelOption[] }>('/api/labels/options', {
      params: {
        q: params.q || undefined,
        limit: params.limit,
      },
    });
    return response.data.labels;
  },

  /** POST /api/labels/merge */
  merge: async (data: MergeLabelsData): Promise<LabelMutationResult> => {
    const response = await api.post<LabelMutationResult>('/api/labels/merge', data);
    return response.data;
  },

  /** POST /api/labels/delete */
  delete: async (data: DeleteLabelData): Promise<LabelMutationResult> => {
    const response = await api.post<LabelMutationResult>('/api/labels/delete', data);
    return response.data;
  },

  /** POST /api/labels/cleanup */
  cleanup: async (): Promise<LabelMutationResult> => {
    const response = await api.post<LabelMutationResult>('/api/labels/cleanup');
    return response.data;
  },
};

export default labelsService;
